import React, { Component, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { MdAdd, MdOutlineHelp, IoSettingsOutline } from '../../Common/Icons';
import { GoAlertFill } from 'react-icons/go';

import SidePanel from '../SidePanel/SidePanel';
import SearchBar from '../SearchBar/SearchBar';

import {
  checkError,
  logout,
  removeTokenCookies,
} from '../../Helpers/AuthHelper';
import { restRequest } from '../../Helpers/RequestHelper';
import { imagePathS3 } from '../../Helpers/RequestHelper';
import { ssosignoutPath } from '../../Helpers/UrlHelper';
import { getCurrentOrganization } from '../../Helpers/CurrentSession';

import logo from '../../Assets/Img/logo.svg';
import orgImage from '../../Assets/Img/org-image.jpg';
import './Header.css';
import './../../Pages/Navigation/Navigation.css';
import QuickAdd from '../QuickAdd/QuickAdd';
import SettingsDropDown from '../SettingsDropDown/SettingsDropDown';
import HelpSection from '../HelpSection/HelpSection';
import {
  isAndroid,
  isTablet,
  isIOS,
  isWinPhone,
  isMobile,
} from 'mobile-device-detect';
import { getOldAcc } from '../../Helpers/GetOldAccount';
import { ImageUrl } from '../../Helpers/ImageUrl';
import { withTranslation } from 'react-i18next';
import USA from '../../Assets/SVG/united-states-flag-icon.svg';
import CH from '../../Assets/SVG/china-flag-icon.svg';
// import { CustomModal } from '../UnsyncOrders';
import { CustomModal } from '../../Components';

class Header extends Component {
  ssosignoutLink = ssosignoutPath();
  sidePanelFlag = false;
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: null,
      showSidePanel: false,
      showQuickAdd: false,
      showSettingsDropDown: false,
      taxcount: 0,
      deliverycount: 0,
      showHelpSection: false,
      organizations: [],
      planLimit: {},
      free_plan: false,
      loading: true,
      exportBtn: JSON.parse(localStorage.getItem('exportBtn')) || false,
      currentOrg: {
        logo: orgImage,
        name: null,
        email: null,
      },
      // Add language dropdown state
      showLanguageDropdown: false,
      languageLoading: false,
      languageModal: false,
      redirect_to_payment_page: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleResultOutsideClick);
    window.addEventListener('storage', this.handleStorageChange);
    window.addEventListener('storageUpdate', this.handleStorageChange); // Custom event

    window.addEventListener('resize', this.resize.bind(this));
    this.fetchFilteredData();
    this.fetchData();
    this.resize();

    this.handleStorageChange();
  }

  // Example of using it

  isMobileScreen = () =>
    isMobile || isAndroid || isTablet || isIOS || isWinPhone;

  resize() {
    this.setState({ screenWidth: window.innerWidth <= 760 });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('storageUpdate', this.handleStorageChange); // Clean up custom event listener
  }

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', `organizations`)
      .then((res) => {
        let currentOrganization = res.organizations.find(
          (org) => org.organizations.id === getCurrentOrganization().id
        );
        if (res?.redirect_to_payment_page) {
          this.setState({ redirect_to_payment_page: true }, () => {
            this.props.history.push('/packagesplan');
          });
        }
        this.setState({
          organizations: res.organizations,
          planLimit: res.plan_limit,
          loading: false,
          currentOrg: {
            logo:
              currentOrganization && currentOrganization.organizations.logo
                ? ImageUrl(currentOrganization.organizations.logo)
                : ImageUrl(orgImage)
                ? orgImage
                : imagePathS3(orgImage),
            name: currentOrganization && currentOrganization.organizations.name,
            email:
              currentOrganization &&
              currentOrganization.organizations.primary_contact_email
                ? currentOrganization.organizations.primary_contact_email
                : '',
          },
        });
        if (this.state.planLimit.hasOwnProperty('pkg_type')) {
          this.setState({
            free_plan: true,
            planLimit: { status: true },
          });
        }
      })
      .catch((error) => {
        checkError(error);
      });
  }
  handleStorageChange = () => {
    const exportBtnData = localStorage.getItem('exportBtn');

    if (exportBtnData !== null) {
      this.setState({ exportBtn: exportBtnData });
    } else {
      this.setState({ exportBtn: false });
    }
  };

  async fetchFilteredData() {
    this.setState({ reportLoading: true });
    // let { taxcount, deliverycount } = this.state;

    return await restRequest('get', `accounts/system-settings`)
      .then((res) => {
        this.setState({
          taxcount: res.taxes,
          deliverycount: res.deliveryMethods,
          reportLoading: false,
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ reportLoading: false });
      });
  }

  homeRoute() {
    return process.env.REACT_APP_HOME;
  }
  handleResultOutsideClick = (event) => {
    if (
      this.sidePanelElement &&
      !this.sidePanelElement.contains(event.target) &&
      this.organizationImageButton &&
      !this.organizationImageButton.contains(event.target)
    ) {
      this.setState({
        showSidePanel: false,
      });
    }

    if (
      this.quickSettings &&
      !this.quickSettings.contains(event.target) && //did this because the above condition returned undefined for settings button, So handled it in a different way.
      this.settingButtonRef &&
      !this.settingButtonRef.contains(event.target)
    ) {
      this.setState({
        showSettingsDropDown: false,
      });
    }

    if (
      this.quickElement &&
      !this.quickElement.contains(event.target) && //did this because the above condition returned undefined for settings button, So handled it in a different way. The quick add button closes now when clicked outsite.
      this.quickAddButtonElement &&
      !this.quickAddButtonElement.contains(event.target)
    ) {
      this.setState({
        showQuickAdd: false,
      });
    }

    if (
      this.quickHelp &&
      !this.quickHelp.contains(event.target) && //did this because the above condition returned undefined for settings button, So handled it in a different way. The quick add button closes now when clicked outsite.
      this.helpButtonRef &&
      !this.helpButtonRef.contains(event.target)
    ) {
      this.setState({
        showHelpSection: false,
      });
    }
  };

  accountRoute() {
    return `/myaccount`;
  }

  handleLogout = () => {
    const sso_connected =
      process.env.REACT_APP_SSO_ENABLED === 'false' ? false : true;
    this.setState({
      loading: true,
    });
    // restRequest('get', 'ssoSettings')
    //   .then((res) => {
    if (sso_connected) {
      //removeTokenCookies();
      window.location.href = this.ssosignoutLink;
      this.setState({ loading: false });
    } else {
      logout();
      //this.props.history.push('/');
    }
    // })
    // .catch((error) => {
    //   logout();
    //   this.props.history.push('/');
    //   this.setState({ loading: false });
    // });
    // logout();
    // this.props.history.push('/');
  };

  languages = [
    {
      code: 'en',
      name: 'English',
      flag: USA,
      displayName: 'English',
    },
    {
      code: 'zh',
      name: 'Chinese',
      flag: CH,
      displayName: 'Chinese',
    },
  ];

  getCurrentLanguageData = () => {
    const currentLang = this.props?.i18n?.language || 'en';
    return (
      this.languages.find((lang) => lang.code === currentLang) ||
      this.languages[0]
    );
  };

  handleChangeLanguage = async (languageCode) => {
    if (languageCode === this.props?.i18n?.language) {
      this.setState({ showLanguageDropdown: false });
      return;
    }
    this.setState({ languageModal: true, currentLanguagcode: languageCode });
    // If same language is selected, just close dropdown
  };
  handleSubmitLanguage = async () => {
    if (this.state.currentLanguagcode === this.props?.i18n?.language) {
      this.setState({ showLanguageDropdown: false });
      return;
    }

    this.setState({
      languageLoading: true,
      showLanguageDropdown: false,
    });

    const selectedLanguage = this.languages.find(
      (lang) => lang.code === this.state.currentLanguagcode
    );

    const language = {
      language: selectedLanguage.name.toLowerCase(),
      language_code: this.state.currentLanguagcode,
    };

    try {
      await restRequest('put', `organizations/default_language`, language);

      // this.props.handleToast('Language Changed', 'success');
      this.props.i18n.changeLanguage(this.state.currentLanguagcode);
      window.location.reload();
    } catch (error) {
      console.error(error);
      this.setState({
        languageLoading: false,
      });
    }
  };
  toggleLanguageDropdown = () => {
    this.setState((prevState) => ({
      showLanguageDropdown: !prevState.showLanguageDropdown,
    }));
  };
  // handleChangeLanguage = async () => {
  //   this.setState({
  //     loading: true,
  //   });

  //   let language = {};

  //   if (this.props?.i18n?.language === 'en') {
  //     // this.props.i18n.changeLanguage('zh');
  //     language = {
  //       language: 'chinese',
  //       language_code: 'zh',
  //     };
  //   } else {
  //     // this.props.i18n.changeLanguage('en');
  //     language = {
  //       language: 'english',
  //       language_code: 'en',
  //     };
  //   }

  //   restRequest('put', `organizations/default_language`, language)
  //     .then(() => {
  //       // this.props.handleToast('Language Changed', 'success');
  //       if (this.props?.i18n?.language === 'en') {
  //         this.props.i18n.changeLanguage('zh');
  //       } else {
  //         this.props.i18n.changeLanguage('en');
  //       }
  //       window.location.reload();
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       this.setState({
  //         loading: false,
  //       });
  //     });
  // };

  render() {
    const { exportBtn } = this.state;
    const { name, email } = this.props.currentUser;
    const { ssoConnected, t, i18n } = this.props;
    const currentLang = this.getCurrentLanguageData();
    const currentLanguageCode = i18n?.language || 'en';
    const currentOrganization = getCurrentOrganization();

    function closeMe() {
      this.setState({
        showSidePanel: false,
        showQuickAdd: false,
        showSettingsDropDown: false,
        showHelpSection: false,
      });
    }
    function hideQuickAdd() {
      setTimeout(() => {
        this.setState({
          showQuickAdd: false,
        });
      }, 0);
    }
    function onClose() {
      this.setState({
        languageModal: false,
      });
    }
    return (
      <>
        {/* <div>
          {JSON.parse(exportBtn) ? (
            <ProgressBar
              now={60}
              variant="info"
              // label={`${60}%`}
              style={{ height: '4px' }}
            />
          ) : null}
        </div> */}
        <div
          className="header header-mobile"
          onClick={
            this.isMobileScreen() ? this.props.toggleNavigationHeader : null
          }
        >
          <div className={classNames('header-left')}>
            <Link
              to="/"
              className="header-logo"
              onClick={() => sessionStorage.setItem('expandSettings', false)}
              style={{
                pointerEvents: this.state.redirect_to_payment_page
                  ? 'none'
                  : 'auto',
                opacity: this.state.redirect_to_payment_page ? 0.5 : 1,
              }}
            >
              {' '}
              {/*collapse settings tab on page reload*/}
              <img src={logo} alt="SeeBiz IMS" />
            </Link>
            <div
              className="header-icon-set d-flex align-center"
              title="Quick Actions"
              ref={(element) => {
                this.quickAddButtonElement = element;
              }}
              style={{
                pointerEvents: this.state.redirect_to_payment_page
                  ? 'none'
                  : 'auto',
                opacity: this.state.redirect_to_payment_page ? 0.5 : 1,
              }}
            >
              <MdAdd
                style={{ marginLeft: '73px' }}
                title="Quick Actions"
                className={`material-icon pointer custom-transition ${
                  this.state.showQuickAdd ? 'add-transform' : ''
                }`}
                onClick={() => {
                  this.setState({
                    showQuickAdd: !this.state.showQuickAdd,
                  });
                  this.setState({
                    showSidePanel: this.state.showSidePanel ? false : false,
                  });
                  if (this.props.viewNavigation && this.isMobileScreen())
                    this.props.toggleNavigation();
                }}
              />
            </div>
          </div>
          <div
            className="header-center header-responsive-main"
            style={{
              pointerEvents: this.state.redirect_to_payment_page
                ? 'none'
                : 'auto',
              opacity: this.state.redirect_to_payment_page ? 0.5 : 1,
            }}
          >
            <SearchBar />
          </div>

          {this.state.planLimit.status === false &&
            this.state.planLimit.expired === 'expired' && (
              <div className="header-center">
                <p
                  className="alert-exceed-packageplan"
                  style={{ marginBottom: '0', marginLeft: '10px' }}
                >
                  {' '}
                  {t('common.plan_expired')}
                  <Link to="/packagesplan"> {t('common.upgrade')}</Link>{' '}
                </p>
              </div>
            )}
          {this.state.planLimit.status === false &&
            this.state.planLimit.expired === 'expiring_soon' && (
              <div className="header-center">
                <p
                  className="alert-exceed-packageplan"
                  style={{ marginBottom: '0', marginLeft: '10px' }}
                >
                  {t('common.expiry_soon')}
                </p>
              </div>
            )}
          {this.state.planLimit.status === false &&
            this.state.planLimit.limit_exceeded === true && (
              <div className="header-center">
                <p
                  className="alert-exceed-packageplan"
                  style={{ marginBottom: '0', marginLeft: '10px' }}
                >
                  {' '}
                  {t('greeting')} {t('common.limit_exceed')}
                  <Link to="/packagesplan"> {t('common.upgrade')}</Link>{' '}
                </p>
              </div>
            )}
          {this.state.free_plan === true && (
            <div className="header-center">
              <p
                className="alert-exceed-packageplan"
                style={{ marginBottom: '0', marginLeft: '10px' }}
              >
                {' '}
                {t('common.free_plan')}
                <Link to="/packagesplan"> {t('common.upgrade')}</Link>{' '}
              </p>
            </div>
          )}

          {/* <button onClick={this.handleChangeLanguage}>
            {' '}
            {t('common.change')}
          </button> */}

          <div className="header-center">
            {JSON.parse(exportBtn) && (
              <p
                // className="alert-exceed-packageplan"
                style={{ marginBottom: '0', marginLeft: '25px' }}
              >
                <strong> {t('common.downloading')}</strong>
              </p>
            )}
          </div>
          {this.state.languageModal && (
            <LanguageChangeModal
              languageModal={this.state.languageModal}
              onClose={onClose.bind(this)}
              handleSubmitLanguage={this.handleSubmitLanguage}
            />
          )}
          <div className="header-right header-responsive-right">
            <GetOldAcc
              onClick={() => {
                localStorage.setItem('skipBtnoldAccount', false);
                this.props.history.push('/');
                if (this.props.viewNavigation && this.isMobileScreen())
                  this.props.toggleNavigation();
              }}
              t={t}
            />

            {currentOrganization?.show_lang_in_header && (
              <div>
                <div
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    textAlign: 'left',
                  }}
                >
                  <button
                    onClick={this.toggleLanguageDropdown}
                    disabled={this.state.languageLoading}
                    className={`language-btn-toggle ${
                      this.state.languageLoading ? 'btn-disabled' : ''
                    }`}
                  >
                    <div className="language-selection">
                      {/* <span style={{ fontSize: '20px' }}>{currentLang.flag}</span> */}
                      <img
                        src={currentLang.flag}
                        alt="Country flag"
                        width={20}
                        height={20}
                      />
                    </div>
                    <svg
                      className={`dropdown-arrow ${
                        this.state.showLanguageDropdown ? 'opened' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {this.state.showLanguageDropdown && (
                    <div className="language-dropdown">
                      <div style={{ padding: '4px 0' }}>
                        {this.languages.map((language) => (
                          <button
                            key={language.code}
                            onClick={() =>
                              this.handleChangeLanguage(language.code)
                            }
                            className={`language-option ${
                              currentLanguageCode === language.code
                                ? 'selected-language'
                                : ''
                            }`}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#eff6ff';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor =
                                currentLanguageCode === language.code
                                  ? '#eff6ff'
                                  : '#ffffff';
                            }}
                          >
                            {/* <span
                            style={{ fontSize: '16px', marginRight: '8px' }}
                          >
                            {language.flag}
                          </span> */}
                            <img
                              src={language.flag}
                              alt="Country flag"
                              width={20}
                              height={20}
                            />
                            <span style={{ flex: '1' }}>
                              {language.displayName}
                            </span>
                            {/* {currentLanguageCode === language.code && (
                          <span style={{ color: '#2563eb', fontWeight: '500' }}>
                            ✓
                          </span>
                        )} */}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Loading Overlay */}
                  {this.state.languageLoading && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        right: '0',
                        bottom: '0',
                        backgroundColor: 'rgba(255, 255, 255, 0.75)',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <div
                        style={{
                          width: '16px',
                          height: '16px',
                          border: '2px solid #e5e7eb',
                          borderTop: '2px solid #2563eb',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite',
                        }}
                      ></div>
                    </div>
                  )}

                  {/* Click outside to close */}
                  {this.state.showLanguageDropdown && (
                    <div
                      style={{
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        right: '0',
                        bottom: '0',
                        zIndex: '0',
                      }}
                      onClick={() =>
                        this.setState({ showLanguageDropdown: false })
                      }
                    />
                  )}
                </div>

                {/* Add this CSS for the loading spinner animation somewhere in your component or global CSS */}
                <style jsx>{`
                  @keyframes spin {
                    from {
                      transform: rotate(0deg);
                    }
                    to {
                      transform: rotate(360deg);
                    }
                  }
                `}</style>
              </div>
            )}
            <div className="header-user">
              <strong> {t('common.hello')}</strong>
              <span>{name ? name : email}</span>
            </div>
            <div
              id="settings_dropdown"
              title="Settings"
              ref={(element) => {
                this.settingButtonRef = element;
              }}
              style={{
                pointerEvents: this.state.redirect_to_payment_page
                  ? 'none'
                  : 'auto',
                opacity: this.state.redirect_to_payment_page ? 0.5 : 1,
              }}
            >
              <IoSettingsOutline
                id="settings_icon"
                title={t('common.settings')}
                className={`material-icon pointer blue-icon ${
                  this.state.showSettingsDropDown ? 'settings-transform' : ''
                }`}
                onClick={() => {
                  this.setState({
                    showSettingsDropDown: !this.state.showSettingsDropDown,
                  });
                  this.setState({
                    showSidePanel: this.state.showSidePanel ? false : false,
                  });
                  if (this.props.viewNavigation && this.isMobileScreen())
                    this.props.toggleNavigation();
                }}
              />
            </div>

            <div
              id="help_section"
              title={t('common.help')}
              ref={(element) => {
                this.helpButtonRef = element;
              }}
              style={{
                pointerEvents: this.state.redirect_to_payment_page
                  ? 'none'
                  : 'auto',
                opacity: this.state.redirect_to_payment_page ? 0.5 : 1,
              }}
            >
              <MdOutlineHelp
                id="help_icon"
                className="material-icon blue-icon"
                style={{ marginRight: '1.7rem' }}
                onClick={() => {
                  this.setState({
                    showHelpSection: !this.state.showHelpSection,
                  });
                  this.setState({
                    showSidePanel: this.state.showSidePanel ? false : false,
                  });
                  if (this.props.viewNavigation && this.isMobileScreen())
                    this.props.toggleNavigation();
                }}
              />
            </div>
            <div
              id="currentOrg_name"
              title={this.state.currentOrg.name}
              className="user-avatar pointer"
              onClick={() => {
                this.setState({
                  showSidePanel: this.state.showSidePanel ? false : true,
                });
                this.setState({
                  showSettingsDropDown: this.state.showSettingsDropDown
                    ? false
                    : false,
                });
                if (this.props.viewNavigation && this.isMobileScreen())
                  this.props.toggleNavigation();
                if (this.sidePanelFlag !== true) {
                  this.sidePanelFlag = true;
                }
              }}
            >
              <div
                id="currentOrg_circle"
                className="image_circle_dp"
                ref={(element) => {
                  this.organizationImageButton = element;
                }}
              >
                <img
                  id="currentOrg_logo"
                  src={this.state.currentOrg.logo}
                  alt="OrganiztionImg"
                />
              </div>
            </div>

            {this.sidePanelFlag ? (
              <div
                ref={(element) => {
                  this.sidePanelElement = element;
                }}
              >
                <SidePanel
                  showSidePanel={this.state.showSidePanel}
                  closeMe={closeMe.bind(this)}
                  handleLogout={this.handleLogout}
                  handleToast={this.props.handleToast}
                  history={this.props.history}
                  ssoConnected={ssoConnected}
                  redirect_to_payment_page={this.state.redirect_to_payment_page}
                />
              </div>
            ) : null}

            <div
              ref={(element) => {
                this.quickElement = element;
              }}
            >
              {this.state.showQuickAdd && (
                <QuickAdd hideQuickAdd={hideQuickAdd.bind(this)} />
              )}
            </div>

            <div
              className={`help_section help-mob ${
                this.state.showHelpSection ? 'show' : ''
              }`}
              ref={(element) => {
                this.quickHelp = element;
              }}
            >
              {this.state.showHelpSection && (
                <HelpSection closeMe={closeMe.bind(this)} />
              )}
            </div>

            <div
              ref={(element) => {
                this.quickSettings = element;
              }}
            >
              {/*this.state.showSettingsDropDown && <SettingsDropDown value={this.state} closeMe={closeMe.bind(this)} />*/}
              {this.state.showSettingsDropDown && (
                <SettingsDropDown
                  closeMe={closeMe.bind(this)}
                  value={this.state}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const GetOldAcc = ({ onClick, t }) => {
  const [skipButton, setSkipButton] = useState({
    skip: null,
    organization: null,
  });
  const skipBtnValue = JSON.parse(localStorage.getItem('skipBtnoldAccount'));
  const organizationValue = JSON.parse(
    localStorage.getItem('currentOrganization')
  )?.mapped_account_status;
  useEffect(() => {
    setSkipButton({
      skip: skipBtnValue,
      organization: organizationValue,
    });
  }, [skipBtnValue]);
  return (
    <>
      {skipButton.skip && !skipButton.organization && (
        <div
          className="alert_icon"
          onClick={onClick}
          style={{ marginRight: '8px' }}
        >
          <GoAlertFill
            id="settings_icon"
            style={{ color: 'red' }}
            title={t('mapAccount.tooltip')}
            className="material-icon pointer"
          />
          <span>{t('mapAccount.label')}</span>
        </div>
      )}
    </>
  );
};

const LanguageChangeModal = ({
  languageModal,
  onClose,
  handleSubmitLanguage,
}) => {
  return (
    <CustomModal
      type="submit"
      showModal={languageModal}
      title="Selelct Language"
      closeLabel="Close (关闭)"
      confirmLabel="Save (节省)"
      onClose={onClose}
      onSubmit={handleSubmitLanguage}
    >
      The selected language will be applied to your account and all invited
      users. Would you like to proceed with this change?
      <br />
      所选语言将应用于您的帐户和所有受邀用户。您是否要继续更改？
    </CustomModal>
  );
};
export default withRouter(withTranslation()(Header));
